import React from "react";
import program01 from "../assets/images/program01.webp";
import program02 from "../assets/images/program02.webp";
import program03 from "../assets/images/program03.webp";

const ProgramHighlightComponent = () => {
  return (
    <section className="ProgrammeHigh">
      <div className="container">
        <h2 className="title">Programme highlights</h2>
        <div className="row justify-content-evenly my-md-5">
          <div className="col-md-12 m-auto">
            <div className="owl-carousel owl-theme" id="ProgrammeHigh">
              <div className="item">
                <div className="ProgrammeHighDetail">
                  <img
                    src={program01}
                    alt="Get post graduate diploma in banking with ICICI Careers Probationary Officer programme"
                    width="358px"
                    height="346px"
                  />
                  <div className="ProgrammeHighContent">
                    <p>
                      Get 2 month <br /> comprehensive training programme
                    </p>
                  </div>
                </div>
              </div>
              <div className="item">
                <div className="ProgrammeHighDetail">
                  <img
                    src={program02}
                    alt="Start your banking career with ICICI Careers Probationary Officer programme"
                    width="358px"
                    height="346px"
                  />
                  <div className="ProgrammeHighContent">
                    <p>
                      Curriculum designed by experts with decades of experience
                      in banking
                    </p>
                  </div>
                </div>
              </div>
              <div className="item">
                <div className="ProgrammeHighDetail">
                  <img
                    src={program03}
                    alt="Get real life learning with ICICI Careers Probationary Officer programme"
                    width="358px"
                    height="346px"
                  />
                  <div className="ProgrammeHighContent">
                    <p>
                      Gain real-life learning experience with case studies,
                      hands-on training and state of the art infrastructures
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProgramHighlightComponent;
